import React from 'react'
import AdminDashboardPage from './AdminDashboardPage'

function AdminGalleryPage() {
  return <AdminDashboardPage section="gallery" />
}

export default AdminGalleryPage
